var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "87px",
    viewBox: "0 0 56 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 55.70436 0 0 55.5524732 0 55.5524732 55.70436 8.7605368e-16 55.70436"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 87 55.5527887 87 55.5527887 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2",
    transform: "translate(-956.000000, -38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(956.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5524732,27.8517055 C55.5524732,43.2356782 43.1149521,55.70436 27.7764732,55.70436 C12.4356282,55.70436 -0.000315492958,43.2356782 -0.000315492958,27.8517055 C-0.000315492958,12.4685236 12.4356282,-0.000158181818 27.7764732,-0.000158181818 C43.1149521,-0.000158181818 55.5524732,12.4685236 55.5524732,27.8517055",
    id: "Fill-1",
    fill: "#FFD356",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFC743",
    mask: "url(#mask-4)",
    points: "15.276169 59.6116091 40.2750423 59.6116091 40.2750423 52.6476545 15.276169 52.6476545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9858141,76.9869327 L18.9858141,84.9150055 C18.9858141,85.4472873 19.189307,85.9819418 19.5955042,86.3884691 C20.0024901,86.7957873 20.5356732,86.9998418 21.0672789,86.9998418 C21.5988845,86.9998418 22.1312789,86.7957873 22.5382648,86.3884691 C22.9436732,85.9819418 23.1463775,85.4472873 23.1463775,84.9150055 L23.1463775,76.9869327 L18.9858141,76.9869327 Z",
    id: "Fill-6",
    fill: "#23475F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0673577,85.7487818 C20.8441465,85.7487818 20.6374986,85.6625727 20.4773859,85.5036 C20.3220056,85.3454182 20.2336676,85.1374091 20.2336676,84.9151636 L20.2336676,76.9870909 L19.4023437,76.9870909 L19.4023437,84.9151636 C19.4023437,85.3588636 19.5750761,85.7796273 19.8897803,86.0936182 C20.2052732,86.4084 20.6225127,86.5824 21.0673577,86.5824 C21.2976676,86.5824 21.482231,86.3957455 21.482231,86.1663818 C21.482231,85.9362273 21.2976676,85.7487818 21.0673577,85.7487818",
    id: "Fill-7",
    fill: "#23475F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4038873,76.9869327 L32.4038873,84.9150055 C32.4038873,85.4472873 32.6073803,85.9819418 33.0143662,86.3884691 C33.4213521,86.7957873 33.9529577,86.9998418 34.4853521,86.9998418 C35.0169577,86.9998418 35.5501408,86.7957873 35.956338,86.3884691 C36.3617465,85.9819418 36.5652394,85.4472873 36.5652394,84.9150055 L36.5652394,76.9869327 L32.4038873,76.9869327 Z",
    id: "Fill-8",
    fill: "#23475F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4851155,85.7487818 C34.262693,85.7487818 34.0544676,85.6625727 33.8959324,85.5036 C33.7397634,85.3454182 33.6522141,85.1374091 33.6522141,84.9151636 L33.6522141,76.9870909 L32.8208901,76.9870909 L32.8208901,84.9151636 C32.8208901,85.3588636 32.9928338,85.7796273 33.3083268,86.0936182 C33.623031,86.4084 34.0410592,86.5824 34.4851155,86.5824 C34.7154254,86.5824 34.8999887,86.3957455 34.8999887,86.1663818 C34.8999887,85.9362273 34.7154254,85.7487818 34.4851155,85.7487818",
    id: "Fill-9",
    fill: "#23475F",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#E5EBEF",
    mask: "url(#mask-4)",
    points: "13.8887887 76.9855091 41.664 76.9855091 41.664 59.6116091 13.8887887 59.6116091"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#F6F9FC",
    mask: "url(#mask-4)",
    points: "41.6637634 59.6116882 13.8885521 59.6116882 12.9333972 60.5678973 42.6173408 60.5678973"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#CCD4DC",
    mask: "url(#mask-4)",
    points: "41.6637634 61.5248182 13.8885521 61.5248182 12.9333972 60.5678182 42.6173408 60.5678182"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#F6F9FC",
    mask: "url(#mask-4)",
    points: "41.6637634 62.7042218 13.8885521 62.7042218 12.9333972 63.65964 42.6173408 63.65964"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#CCD4DC",
    mask: "url(#mask-4)",
    points: "41.6637634 64.6158491 13.8885521 64.6158491 12.9333972 63.65964 42.6173408 63.65964"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#F6F9FC",
    mask: "url(#mask-4)",
    points: "41.6637634 65.7960436 13.8885521 65.7960436 12.9333972 66.7546255 42.6173408 66.7546255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#CCD4DC",
    mask: "url(#mask-4)",
    points: "41.6637634 67.7092527 13.8885521 67.7092527 12.9333972 66.7546255 42.6173408 66.7546255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#F6F9FC",
    mask: "url(#mask-4)",
    points: "41.6637634 68.8878655 13.8885521 68.8878655 12.9333972 69.8440745 42.6173408 69.8440745"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#CCD4DC",
    mask: "url(#mask-4)",
    points: "41.6637634 70.8010745 13.8885521 70.8010745 12.9333972 69.8440745 42.6173408 69.8440745"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#F6F9FC",
    mask: "url(#mask-4)",
    points: "41.6637634 71.9804782 13.8885521 71.9804782 12.9333972 72.9398509 42.6173408 72.9398509"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#CCD4DC",
    mask: "url(#mask-4)",
    points: "41.6637634 73.8936082 13.8885521 73.8936082 12.9333972 72.9397718 42.6173408 72.9397718"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#F6F9FC",
    mask: "url(#mask-4)",
    points: "41.6637634 75.0722209 13.8885521 75.0722209 12.9333972 76.0300118 42.6173408 76.0300118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#CCD4DC",
    mask: "url(#mask-4)",
    points: "41.6637634 76.9869327 13.8885521 76.9869327 12.9333972 76.0299327 42.6173408 76.0299327"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    mask: "url(#mask-4)",
    fill: "#FFFFFF",
    opacity: 0.266021286
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.887324, 7.909091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3944225,11.4231791 C8.14011268,14.6880518 3.65538028,15.4829155 1.37673239,13.1979791 C-0.901126761,10.9122518 -0.110028169,6.41672455 3.14428169,3.15264273 C6.39859155,-0.109857273 10.8825352,-0.902348182 13.1603944,1.38100636 C15.439831,3.66594273 14.6487324,8.16147 11.3944225,11.4231791 Z",
    id: "Fill-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2209915,30.4322045 C38.5507944,31.7640955 38.0878085,34.3875409 36.1901183,36.2904682 C34.2932169,38.1933955 31.6754141,38.6552864 30.3471887,37.3226045 C29.0189634,35.9891318 29.4819493,33.36885 31.3788507,31.4651318 C33.2765408,29.5622045 35.8919775,29.0979409 37.2209915,30.4322045",
    id: "Fill-24"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#556D80",
    mask: "url(#mask-4)",
    points: "27.3642817 59.6116091 28.1877183 59.6116091 28.1877183 35.0807727 27.3642817 35.0807727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#556D80",
    mask: "url(#mask-4)",
    points: "27.7762366 35.6627236 20.5979831 28.46466 21.1792789 27.88176 27.7762366 34.4977145 34.3731944 27.88176 34.9544901 28.46466"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.0672ee8471be28e5847f753e3a5ea5ed.svg";
export { ForwardRef as ReactComponent };